interface ImportMetaEnv {
  VITE_API_URL: string
  VITE_SUPABASE_URL: string
  VITE_SUPABASE_ANON_KEY: string
  VITE_USER_DASHBOARD_URL: string
  VITE_MERCHANT_DASHBOARD_URL: string
}

export const env = {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_USER_DASHBOARD_URL: import.meta.env.VITE_USER_DASHBOARD_URL,
  VITE_MERCHANT_DASHBOARD_URL: import.meta.env.VITE_MERCHANT_DASHBOARD_URL,
}
